import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'
import Icon from '@mdi/react'
import styled from 'styled-components'

export const CreateWlanCollapseHeaderTitle = styled.div`
  flex: 1;
  color: ${theme.colors.otterWarmBlack};
  font-weight: bold;
  max-width: initial;
  word-break: word;
`
export const CreateWlanCollapseBtn = styled(CommonLinkButton)`
  display: flex;
`

export const CreateWlanRightBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 100px;
  max-width: 150px;
  gap: 15px;
  flex: 1;
`

export const CreateWlanLeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 20px;
  width: 100%;
`

export const CreateWlanCollapseIcon = styled(Icon)<{ open?: boolean }>`
  transition: transform 0.3s ease;
  transform: ${({ open }) => (open ? 'rotate(-180deg)' : 'rotate(0)')};
`

export const CreateWlanCollapseHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 24px;

  @media ${theme.devices.tablet} {
    gap: 18px;

    ${CreateWlanLeftBlock} {
      align-items: center;
      flex-direction: row;
    }
  }
`
export const WLANNameHightlighted = styled.span`
  font-weight: 750;
`
